import styled, { css } from 'styled-components';
import { Container as LayoutContainer } from 'styles';

export const pageChildBannerStyles = css`
  width: auto;
  margin-left: -24px;
  margin-right: -24px;
`;

export const Container = styled(LayoutContainer)`
  svg {
    flex-shrink: 0;
  }
`;
